import { render, staticRenderFns } from "./Clients_Form.vue?vue&type=template&id=4d73abf6&scoped=true&"
import script from "./Clients_Form.vue?vue&type=script&lang=js&"
export * from "./Clients_Form.vue?vue&type=script&lang=js&"
import style0 from "./Clients_Form.vue?vue&type=style&index=0&id=4d73abf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d73abf6",
  null
  
)

export default component.exports